import React from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { BsCheckAll } from 'react-icons/bs';

const Message = ({ text, sender, timestamp }) => {
  // Simple check for PDF links to show icon
  const isPdf = text.toLowerCase().includes('.pdf') || sender === 'receipt';

  const renderHTML = (html) => {
    return { __html: html };
  };

  return (
    <div className={`message ${sender}`}>
      {sender === "receipt" || isPdf ? (
        <div className="pdf-attachment">
          <FaFilePdf size={24} color="#ef4444" />
          <a href={text} target="_blank" rel="noopener noreferrer">
            Transaction Receipt
          </a>
        </div>
      ) : (
        <div className="message-content" dangerouslySetInnerHTML={renderHTML(text)} />
      )}

      <div className="message-meta">
        <span className="message-timestamp">{timestamp}</span>
        {sender === 'user' && <BsCheckAll size={16} color="#93c5fd" />}
      </div>
    </div>
  );
};

export default Message;
